<template>
    <el-dialog title="板块编辑" :close-on-click-modal="false" :visible.sync="visible" @close="handClose" width="45%">
        <div style="text-align:right">
            <el-button type="primary" size="small" @click="handleAdd">
                <i  class="el-icon-plus"> 新 增</i>
            </el-button>
        </div>
        <el-table :data="data" style="width: 100%">
            <el-table-column prop="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="title" label="申报项目内容标题"></el-table-column>
            <!-- <el-table-column prop="sort" label="排序" width="80"></el-table-column> -->
            <el-table-column label="操作" width="220">
                <template slot-scope="scope">
                    <el-button @click="moveup(scope.row)" type="text" size="small" class="el-icon-top">上移</el-button>
                    <el-button @click="movedown(scope.row)" type="text" size="small" class="el-icon-bottom">下移</el-button>
                    <el-button @click="handEdit(scope.row)" type="text" size="small" class="el-icon-edit">编辑</el-button>
                    <el-button type="text" size="small" @click="handDelete(scope.row)"  class="el-icon-delete">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background prev-text="上一页" next-text="下一页" layout="total, prev, pager, next, jumper" :total="page.total" :current-page="page.page" :page-size="page.size" :pager-count="page.pagerCount" @current-change="handPageChange" style="margin-top:15px"></el-pagination>

        <el-dialog  width="60%" title="内容编辑" :visible.sync="outVisible" append-to-body  :close-on-click-modal="false">
            <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="80px">
                <el-form-item label="申报项目内容标题" prop="title">
                    <el-input v-model="dataForm.title" placeholder="申报项目内容标题"></el-input>
                </el-form-item>
                <el-form-item label="申报项目内容详情介绍" prop="content">
                    <vue2editor v-model="dataForm.content" @onchange="onchange"></vue2editor>
                </el-form-item>
                <!-- <el-form-item label="排序" prop="sort">
                    <el-input v-model="dataForm.sort" placeholder="排序"></el-input>
                </el-form-item> -->
            </el-form>
             <div slot="footer" class="dialog-footer">
                <el-button @click="outVisible = false">取 消</el-button>
                <el-button type="primary" @click="dataFormSubmit()">确 定</el-button>
            </div>
        </el-dialog>
    </el-dialog>
</template>
<script>
import vue2editor from "@/components/common/vue2editor";
import { add , update , getList , getEntity , remove , getItemSort} from "@/api/shenbao/shenbao-content";
 
export default {
    props: {
        shenbaoId:{
            type: String,
            default: ""
        }
    },
    components: {
        vue2editor,
    },
    data() {
        return {
            index:null,
            dataForm:{},
            visible: false,
            outVisible:false,
            data:[],
            page:{
                page:1,
                size:5,
                total:0
            },
            dataRule:{
                title: [
                    { required: true, message: '请输入标题名称', trigger: 'blur' },
                    { min: 1, max: 5, message: '标题长度应限制在 1 到 5 个字之间', trigger: 'blur' }
                ],
                content:[
                    { required: true, message: '请填充文本内容', trigger: 'blur' },
                ]
            }
        };
    },
    watch:{
        'shenbaoId':{
            immediate: true,
            handler: function (newVal) {
                if(newVal) this.getQueryList()
            }
        }
    },
    methods: {
        moveup(row){
            const { index } = row
            if(index==1){
                this.$message({
                    message: '已经是列表中第一个！',
                    type: 'warning'
                })
            }else{
                getItemSort(row.id,1).then(()=>{
                    this.getQueryList()
                }).catch(()=>{})
            }
        },
        movedown(row){
            const { index } = row
            if(index == this.data.length){
                this.$message({
                    message: '已经是列表中最后一个！',
                    type: 'warning'
                })
            }else{
                getItemSort(row.id,0).then(()=>{
                    this.getQueryList()
                }).catch(()=>{})
            }

        },
        handleAdd(){
            this.dataForm = {}
            this.outVisible = true
        },
        handDelete(row){
            this.$confirm('此操作将删除该选项, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    remove([row.id]).then(()=>{
                        this.$message.success("删除成功!")
                        this.getQueryList()
                    })
                }).catch(() => {});
        },
        onchange(txt){
            this.$set(this.dataForm,'content',txt)
        },
        handClose() {
            this.$emit("close");
        },
        changeVisible(visible = false) {
            this.visible = visible;
        },
        handPageChange(page){
            this.$set(this.page, 'page', page)
            this.getQueryList()
        },
        getQueryList(){
            const { page,size } = this.page
            getList(page,size,{
                    shenbaoId:this.shenbaoId,
                    sidx: 'sort asc'             
                }).then(res=>{
                const { totalCount , list} = res
                this.$set(this.page,'total', totalCount)
                this.index = totalCount
                this.data = list
                this.data.forEach((item,index)=>{
                    item.index = index + 1 + (page-1) * size
                    return item
                })
            })
        },
        dataFormSubmit () {
            this.$refs['dataForm'].validate((valid) => {
            if (valid) {
                if (valid) {
                    let opFun = this.dataForm.id ? update : add;
                    this.dataForm.shenbaoId = this.shenbaoId
                    opFun(this.dataForm).then(()=>{
                        this.outVisible = false;
                        this.getQueryList()
                        this.$message.success("操作成功");
                    })
                }else return false;
            }
            })
        },
        handEdit(row){
            getEntity(row.id).then(res=>{
                this.dataForm = res
                this.outVisible = true
            })
        },
    }
};
</script>
<style lang="less">
.shenbao-editor-dialog {
    height: 400px;
    .w-e-toolbar {
        overflow: visible;
    }
}
</style>